export default function selectCustomisationStage(state) {
  return state.app.customisationStage;
}
